export enum ClientTypesEnum {
  individual = 'INDIVIDUAL',
  soleProprietor = 'SOLE_PROPRIETOR',
  business = 'BUSINESS',
}
